export default function () {
  return /MSIE \d|Trident.*rv:/.test(navigator.userAgent);
}



// WEBPACK FOOTER //
// ./scripts/utils/detect-ie.js